"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubterraneanHabitats = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var MoonCard_1 = require("./MoonCard");
var SubterraneanHabitats = (function (_super) {
    __extends(SubterraneanHabitats, _super);
    function SubterraneanHabitats() {
        return _super.call(this, {
            name: CardName_1.CardName.SUBTERRANEAN_HABITATS,
            cardType: CardType_1.CardType.ACTIVE,
            cost: 12,
            metadata: {
                description: 'Spend 2 steel. Raise the Colony Rate 1 step.',
                cardNumber: 'M36',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you build a colony on the Moon, you spend 1 titanium less.', function (eb) {
                        eb.startEffect.moonColony().colon().minus().titanium(1);
                    });
                    b.br;
                    b.minus().steel(2).moonColonyRate();
                }),
            },
        }, {
            reserveUnits: Units_1.Units.of({ steel: 2 }),
        }) || this;
    }
    ;
    SubterraneanHabitats.prototype.play = function (player) {
        _super.prototype.play.call(this, player);
        MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
        return undefined;
    };
    return SubterraneanHabitats;
}(MoonCard_1.MoonCard));
exports.SubterraneanHabitats = SubterraneanHabitats;
//# sourceMappingURL=SubterraneanHabitats.js.map